module.exports = __webpack_public_path__ + "img/901583962.be24edcd.png";